<template>
  <div class="tabs-demo">
    <vx-card title="">
      <div class="mt-5">
        <div class="management-title">
          <div class="management-tel">
            <el-input v-model="username" placeholder="账号"></el-input>
          </div>
          <div class="management-tel">
            <el-input v-model="realName" placeholder="姓名/手机号"></el-input>
          </div>
<!--          <div class="management-tel">-->
<!--            <el-select v-model="status" placeholder="状态">-->
<!--              <el-option-->
<!--                      v-for="item in options"-->
<!--                      :key="item.value"-->
<!--                      :label="item.label"-->
<!--                      :value="item.value"-->
<!--              >-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
          <div class="management-tel">
            <el-input v-model="deptName" placeholder="所属机构"></el-input>
          </div>
          <div class="management-tel">
            <el-input v-model="roleName" placeholder="所属角色"></el-input>
          </div>

          <div class="management-tel" style="width: 300px">
            <el-button style="width: 100px" type="primary" plain @click="DetailRole(1)"
            >查询</el-button
            >
            <el-button style="width: 80px" type="primary" @click="openAdd" plain >新增</el-button>

            <el-button style="width: 80px" type="info" plain @click="rest()">重置</el-button>
          </div>
        </div>
        <div class="management-body">
          <el-table :data="tableData" v-loading="tableLoading" border style="width: 100%">
            <el-table-column
                    fixed
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
            >
            </el-table-column>
            <el-table-column prop="username" label="账号" width="120">
            </el-table-column>
            <el-table-column prop="mobile" label="手机号" width="120">
            </el-table-column>
            <el-table-column prop="realname" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="main_dept_name" label="主机构" width="150">
            </el-table-column>
            <el-table-column prop="dept_name" label="权限设置机构" width="200">
            </el-table-column>
            <el-table-column prop="role_names" label="角色" width="250"></el-table-column>
            <el-table-column prop="is_main" label="类型" width="250">
              <template slot-scope="scope">{{scope.row.is_main === true?'主职':'兼职'}}</template>
            </el-table-column>
            <el-table-column fixed="right" min-width="120" label="操作" v-if="filtering('user:update')">
              <template #default="scope">
                <el-button
                        v-if="filtering('personnelAuthority:update')"
                        @click="openEdit(scope.row)"
                        type="text"
                        size="small"
                >编辑</el-button>
                <el-button
                        v-if="filtering('personnelAuthority:delete')"
                        @click="deldteClick(scope.row)"
                        type="text"
                        size="small"
                >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 20px 0 0 0; text-align: center">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-size="pageSize"
                    layout="total, sizes , prev, pager, next , jumper"
                    :total="pageTotal"
            >
            </el-pagination>
          </div>
        </div>
        <!-- 编辑弹窗 -->
        <vs-prompt title="修改人员权限" @close="closeAdd" :active.sync="editModal" class="form_box">
          <div class="con-exemple-prompt">
            <el-form
                    :model="editForm"
                    :rules="rules"
                    ref="newForm"
                    label-width="100px"
                    class="demo-ruleForm"
            >
              <div class="management-customer">账号信息</div>
              <el-form-item label="账号" prop="username">

                <el-input placeholder="请输入内容" :disabled="true" v-model="editForm.username" style="width: 300px" class="input-with-select">
                  <el-button slot="append" @click="searchKeyWords" icon="el-icon-search"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realName">
                <el-input
                        :disabled="true"
                        style="width: 300px"
                        v-model="editForm.realName"
                        placeholder="姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input
                        :disabled="true"
                        style="width: 300px"
                        maxlength="11"
                        v-model="editForm.mobile"
                        placeholder="手机号"
                ></el-input>
              </el-form-item>
              <div>
                <div class="management-customer">组织信息</div>
                <el-form-item label="机构" prop="deptId">
                  <el-input v-show="!isEdit" @focus="showEditTree" style="width: 300px" v-model="tempName"></el-input>
                  <el-cascader
                          v-show="isEdit"
                          placeholder="请选择机构"
                          :options="organizationList"
                          :props="cascaderProps"
                          style="width: 300px"
                          @change="getcascadercode"
                          v-model="editForm.deptId"
                          :show-all-levels="false"
                          filterable
                          clearable></el-cascader>
                </el-form-item>
                <div class="management-customer">角色信息</div>
                <el-form-item label="角色" prop="roleIds">
                  <el-cascader
                          @change="searchRole"
                          v-model="editForm.roleIds"
                          style="width: 300px"
                          :options="roleList"
                          :props="roleProps"
                          clearable></el-cascader>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="exemple_footer">
            <el-button type="primary" style="width: 100px" :loading="btnLoading" @click="submitEdit()" plain
            >保存</el-button
            >
            <el-button style="width: 100px" @click="closeAdd"
            >取消</el-button
            >
          </div>
        </vs-prompt>

        <!-- 新增弹窗 -->
        <vs-prompt title="新增人员权限" @close="closeAdd" :active.sync="addModal" class="form_box">
          <div class="con-exemple-prompt">
            <el-form
                    :model="newForm"
                    :rules="newRules"
                    ref="newForm"
                    label-width="100px"
                    class="demo-ruleForm"
            >
              <div class="management-customer">账号信息</div>
              <el-form-item label="账号" prop="username">

                <el-input placeholder="请输入内容" v-model="newForm.username" style="width: 300px" class="input-with-select">
                  <el-button slot="append" @click="searchKeyWords" icon="el-icon-search"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realName">
                <el-input
                        :disabled="true"
                        style="width: 300px"
                        v-model="newForm.realName"
                        placeholder="姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input
                        :disabled="true"
                        style="width: 300px"
                        maxlength="11"
                        v-model="newForm.mobile"
                        placeholder="手机号"
                ></el-input>
              </el-form-item>
              <div>
                <div class="management-customer">组织信息</div>
                <el-form-item  label="机构" prop="deptId">
                  <el-cascader
                          placeholder="机构"
                          :options="organizationList"
                          :props="cascaderProps"
                          style="width: 300px"
                          @change="getcascadercode"
                          v-model="newForm.deptId"
                          :show-all-levels="false"
                          filterable
                          clearable></el-cascader>
                </el-form-item>
                <div class="management-customer">角色信息</div>
                <el-form-item label="角色" prop="roleIds">
                  <el-cascader
                          @change="searchRole"
                          v-model="newForm.roleIds"
                          style="width: 300px"
                          :options="roleList"
                          :props="roleProps"
                          clearable></el-cascader>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="exemple_footer">
            <el-button type="primary" style="width: 100px" :loading="btnLoading" @click="submitAdd()" plain
            >保存</el-button
            >
            <el-button style="width: 100px" @click="closeAdd"
            >取消</el-button
            >
          </div>
        </vs-prompt>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import { OrderApi } from '@/modules/accounts/getapi'
  var validatorPhone = function (rule, value, callback) {
    if (value === "") {
      callback(new Error("手机号不能为空"));
    } else if (!/^1[3|4|5|7|8][0-9]\d{8}$/.test(value)) {
      callback(new Error("手机号格式错误"));
    } else {
      callback();
    }
  };
  export default {
    data() {
      return {
        isEdit:false,//是否是编辑flag
        tempName:'',//临时字段缓存机构名称
        tableLoading:false,//表格loading
        btnLoading:false,//按钮节流
        editModal:false,
        loading: false,//账号检索loading
        addModal:false,//新增人员权限弹窗
        accountList:[],//账号搜索服务端列表
        roleList:[],//角色列表
        organizationList:[],//组织机构列表
        cascaderProps: {
          children: "children",
          label: "name",
          value:'id',
          checkStrictly: true,
          lazy: true,
          async lazyLoad(node,resolve) {
            let id = node.data.id;
            let res = await OrderApi.structure({}, id);
            resolve(res.data);
          }
        },//组织机构属性
        roleProps:{
          children: "children",
          label: "name",
          value:'id',
          multiple: true,
          checkStrictly:true
        },//角色列表树属性
        pageIndex: 1,
        pageSize: 10,
        pageTotal: null,
        username:'',
        realName:'',
        deptName:'',
        roleName:'',
        tableData: [],
        options: [{
          value: '0',
          label: '禁用'
        }, {
          value: '1',
          label: '有效'
        },{
          value: '2',
          label: '禁止登陆'
        }],
        status:'',//状态
        dialogVisible: false, //新增编辑弹框
        newForm:{
          userId:'',//账号
          realName:'',//姓名
          mobile:'',//手机号
          deptId:'',//机构id
          roleIds:[],//数据权限
        },
        editForm:{
          userId:'',//账号
          realName:'',//姓名
          mobile:'',//手机号
          deptId:'',//机构id
          roleIds:[],//数据权限
        },
        newRules:{
          username:[ { required: true, message: "请输入账号", trigger: "remote-method" },],
          realName:[ { required: true, message: "请输入姓名", trigger: "blur" },],
          mobile:[ { required: true, message: "请输入手机号", trigger: "blur" }],
          deptId:[ { required: true, message: "请选择机构", trigger: "change" },],
          roleIds:[ { required: true, message: "请选择角色", trigger: "change" },],
        },
        ruleForm: {
          accountnumber:'',//账号
          name:'',//姓名
          phonenumber:'',//手机号
          Initial:'',//初始密码
          desc:'',//备注
          deptId:'',//机构id
          deptIds:'',//附属机构
          roleId:'',//数据权限
        },
        rules: {
          username:[ { required: true, message: "请输入账号", trigger: "remote-method" },],
          realName:[ { required: true, message: "请输入姓名", trigger: "blur" },],
          mobile:[ { required: true, message: "请输入手机号", trigger: "blur" }],
          deptId:[ { required: true, message: "请选择机构", trigger: "change" },],
          roleIds:[ { required: true, message: "请选择角色", trigger: "change" },],
        },
        Datapermissions:[],
        data:[],
        subsidiaryProps: {
          children: "children",
          label: "name",
          value:'id',
          multiple: true,
          checkStrictly:true
        },

      };
    },
    created () {
      this.organization(0);//获取机构
      this.DetailRole();
      this.getRoleList();//获取角色列表
    },
    watch:{
      "newForm.username":function (val) { //监听账号为空，清空姓名手机号
        if(val === ''){
          this.newForm.realName = '';
          this.newForm.mobile = '';
          this.newForm.userId = '';
        }
      }
    },
    methods: {
      //点击文本显示懒加载tree
      showEditTree(){
        this.isEdit = true;
        console.log(11);
      },
      //校验是否为二维数组
      isMultiArr(arr){
        var a =1;
        for (var i=0;i<arr.length;i++){
          if(arr[i] instanceof Array){
            a++;
            arr = arr[i];
            this.isMultiArr(arr);
          }
        }
        return a;
      },
      closeAdd(){
        this.newForm = {
          userId: '',//账号
          realName: '',//姓名
          mobile: '',//手机号
          deptId: '',//机构id
          roleIds: [],//数据权限
        }
        this.isEdit = false;
        this.editModal = false;
        this.addModal = false;
      },
      async submitEdit(){
        let arr = JSON.parse(JSON.stringify(this.editForm.roleIds));
        var roleArr = [];
        //校验数组是否是二维
        if(this.isMultiArr(arr) === 2){
          arr.forEach(item=>{
            roleArr.push(item.pop())
          })
        }else{
          roleArr = arr;
        }
        this.editForm.deptId = Array.isArray(this.editForm.deptId)?this.editForm.deptId.pop():this.editForm.deptId;
        if(roleArr.length === 0){
          this.$message.error('请选择角色');
          return  false;
        }
        this.btnLoading = true;
        let params = {
          userId:this.editForm.userId,//账号
          realName:this.editForm.realName,//姓名
          mobile:this.editForm.mobile,//手机号
          deptId:this.editForm.deptId,//机构id
          roleIds:roleArr,//数据权限
          status:this.editForm.status,
          id:this.editForm.id
        }
        let res = await OrderApi.editUserPermission(params);
        if(res.code === 200){
          this.$message.success(res.message);
          this.editModal = false;
          this.DetailRole();
          this.btnLoading = false;
          this.isEdit = false;
        }else{
          this.$message.error(res.message);
          this.btnLoading = false;
        }
      },
      //提交新建人员权限
      async submitAdd(){
        this.btnLoading = true;
        let arr = JSON.parse(JSON.stringify(this.newForm.roleIds));
        let roleArr = [];
        arr.forEach(item=>{
          roleArr.push(item.pop())
        })
        this.newForm.deptId = Array.isArray(this.newForm.deptId)?this.newForm.deptId.pop():this.newForm.deptId;
        let params = {
          userId:this.newForm.userId,//账号
          realName:this.newForm.realName,//姓名
          mobile:this.newForm.mobile,//手机号
          deptId:this.newForm.deptId,//机构id
          roleIds:roleArr,//数据权限
          status:0,
        }
        let res = await OrderApi.addUserPermission(params);
        if(res.code === 200){
          this.$message.success(res.message)
          this.addModal = false;
          this.DetailRole();
          this.btnLoading = false;
          this.closeAdd();
        }else{
          this.$message.error(res.message);
          this.btnLoading = false;
        }
        // console.log(this.newForm);
      },
      //获取所有角色列表
      async getRoleList(){
        let res = await OrderApi.Rolearr({});
        this.roleList = res.data;
        console.log(res.data);
      },
      //获取组织机构
      async organization (id) {
        let res = await OrderApi.structure({},id);
        this.organizationList = res.data;
      },
      //搜索角色
      searchRole(val){
        console.log(val);
      },
      //账号检索
      async searchKeyWords(){
        let res = await OrderApi.QueryAccounts(this.newForm.username);
        if(res.data){
          this.newForm.realName = res.data.realname;
          this.newForm.mobile = res.data.mobile;
          this.newForm.userId = res.data.userId;
        }else{
          this.$message.error('账号不存在');
          this.newForm.realName = '';
          this.newForm.mobile = '';
          this.newForm.userId = '';
        }
      },
      //打开新增弹窗
      openAdd(){
        this.$nextTick(()=>{
          this.addModal = true;

        })
      },
      //更改每页条数
      handleSizeChange(val) {
        this.pageSize = val;
        this.DetailRole(1);
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.DetailRole();
      },
      rest(){
        this.username='';
        this.realName='';
        // this.status='';
        this.deptName='';
        this.roleName='';
        this.DetailRole(1);
        this.pageSize = 10;
        this.pageIndex = 1;
      },
      adercode(e){
        let list = JSON.parse(JSON.stringify(e));
        this.ruleForm.deptIds=list;
      },
      //选择主机构
      getcascadercode(e){
        var tempData = JSON.parse(JSON.stringify(e));
        this.newForm.deptId = tempData.pop();
        // if(tempData.length === 0){
        //   return false;
        // }
        // if(tempData.length>1){
        //   this.newForm.deptId =tempData[tempData.length-1];
        // }else{
        //   this.newForm.deptId = tempData[0];
        // }
      },
      async DetailRole(page){
        this.pageIndex = page || this.pageIndex;
        this.tableLoading = true;
        let data = {
          size: this.pageSize,
          current: this.pageIndex,
          data: {
            username:this.username,
            realName:this.realName,
            deptName:this.deptName,
            roleName:this.roleName,
          }
        }
        let res = await OrderApi.getUserPermission(data);
        if(res.code === 200){
          this.tableData = res.data.records;
          this.pageTotal = res.data.total;
          this.tableLoading = false;
        }else{
          this.$message.error(res.message);
        }



      },
      //打开编辑弹窗
      openEdit(row){
        console.log(row);
        this.tempName = row.dept_name;
        this.editModal = true;
        this.$nextTick(()=>{
          // this.editForm = row;
          this.getInfo(row.id);
        })
      },
      //获取详情
      async getInfo(id){
        let res = await OrderApi.userPermissionInfo(id);
        this.editForm = res.data;
        console.log(this.editForm);
        console.log(res);
      },
      //编辑
      async handleClick(e) {
        console.log(e);
        this.dialogVisible = true;
        let res = await OrderApi.Rolelist({});
        this.Datapermissions=res.data
        let ress = await OrderApi.organization({deptId:'0'});
        this.data=ress.data
        this.id=e.id
        this.ruleForm.accountnumber=e.username
        this.ruleForm.name=e.realname
        this.ruleForm.phonenumber=e.mobile
        this.ruleForm.Initial=e.password

        this.ruleForm.desc=e.description
        this.ruleForm.deptId=e.deptIdLists
        this.ruleForm.deptIds=e.deptPermissionIds
        let arr=[]
        e.role_id.split(",").map(item=>{
          let str = Number(item)
          arr.push(str)
        })
        this.ruleForm.roleId=arr
      },
      //删除
      deldteClick(e) {
        this.$confirm("确认删除此权限", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          center: true,
        })
                .then(() => {
                  this.Stateoperation(e);

                })
                .catch(() => {});
      },
      //操作
      async Stateoperation(e){
        let res = await OrderApi.delUserPermission(e.id);
        //console.log(res)
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "成功!",
          });
          this.DetailRole();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      },
      //保存
      getadd() {
        console.log("保存");
        this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            let arr = []
            if(this.ruleForm.deptIds.length!=0){
              let str = this.ruleForm.deptIds;
              //console.log(str)
              str.map(item=>{
                arr.push([item.toString()])
              })
            }
            console.log(arr)
            let data = {
              username:this.ruleForm.accountnumber,//账号
              password:this.ruleForm.Initial,//密码
              realname:this.ruleForm.name,//姓名
              sex:'0',//性别
              loginStatus:'3',
              email:'',
              mobile:this.ruleForm.phonenumber,//电话
              deptIds:[this.ruleForm.deptId.toString()],//主机构id
              status:'1',
              description:this.ruleForm.desc,//备注
              deptPermissionIds:arr.length==0?'':arr,//附属机构
              roleId:this.ruleForm.roleId.toString(),
              id:this.id
            }
            // let comValue = qs.stringify(data)
            //console.log(data)

            this.editUser(data)

          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //编辑
      async editUser(data){
        let res = await OrderApi.editUser(data);
        if(res.code==200){
          this.$message({
            type: "success",
            message: "编辑成功!",
          });
          this.dialogVisible=false;
          this.DetailRole();

        }else if(res.code==403){
          console
        }else{
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .form_box {
    /deep/ .vs-dialog-text {
      position: relative;
    }
  }
  .form_box {
    /deep/ .vs-component {
      display: none;
    }
    /deep/ footer {
      height: 60px;
    }
  }
  .management-title {
    display: flex;
    flex-wrap: wrap;
  }
  .management-tel {
    width: 200px;
    height: 40px;
    margin-right: 20px;
    margin-bottom: 20px;
    & > input {
      width: 100%;
      height: 100%;
    }
  }
  .management-body {
    width: 100%;
    min-height: 200px;
  }
  .con-exemple-prompt {
    width: 100%;
    height: 500px;
    overflow: auto;
  }

  .exemple_footer {
    width: 32%;
    height: 50px;
    position: absolute;
    z-index: 999999;
    bottom: -60px;
    right: 16px;
    background: white;
  }
  .management-customer {
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 20px;
  }
</style>
